export default "__VITE_ASSET__BBtwkm3r__"